import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Fab,
  makeStyles,
  Card,
  CardContent,
  withStyles,
  Collapse,
  CardActions,
  Button,
  IconButton,
  Container,
  alpha,
  Typography,
  Hidden,
  TextField,
  InputAdornment
} from '@material-ui/core';
import {
  FaqIcon,
  InterrogationIcon,
  LibraryIcon,
  SearchIcon,
  StoreIcon
} from 'app/main/components/icons';
import {
  Search as SearchIconBis,
  Cancel as CancelIcon,
  Close as CloseIcon
} from '@material-ui/icons';
import SearchInput from 'app/main/components/prefabs/SearchInput/SearchInput';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import useAxiosGet from 'hooks/useAxiosGet';
import Autocomplete, {
  createFilterOptions
} from '@material-ui/lab/Autocomplete';
import DisplaySearchItem from './DisplaySearchItem';
import useAxios from 'axios-hooks';

const useStyles = makeStyles(theme => ({
  root: {
    // position: 'absolute',
    // right: 0,
    // bottom: 100,
    zIndex: 9,
    // textAlign: 'right',
    // height: open => (open ? 'initial' : 'auto'),
    // width: open => (open ? 'initial' : 80),
    height: 50,
    width: 50,
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  fab: {
    backgroundColor: '#00000000',
    color: `${theme.palette.text.dynamic}`,
    height: 50,
    width: 50,
    borderRadius: '50%',
    // boxShadow: '0 2px 5px #a1a1a1',
    boxShadow: 'none',
    marginLeft: 32,
    '&:hover': {
      backgroundColor: '#0000001a'
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      height: 60,
      width: 60,
      borderRadius: '50%'
    }
  },
  fabOpen: {
    backgroundColor: '#000000',
    color: '#fff !important',
    boxShadow: '0 2px 5px #010101',
    '&:hover': {
      backgroundColor: '#000000a8'
    }
  },
  fabIcon: {
    fontSize: 26,
    [theme.breakpoints.down('sm')]: {
      fontSize: 30
    }
  },
  sectionClose: {
    flexDirection: 'row-reverse'
  },
  iconClose: {
    color: theme.palette.secondary.main
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 15,
    [theme.breakpoints.down('sm')]: {
      width: 'inherit',
      padding: 0,
      marginBottom: 0
    }
  },
  containerButton: {
    display: 'flex',
    marginBottom: 15,
    gap: 30,
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      width: 'inherit',
      padding: 0,
      marginBottom: 15,
      justifyContent: 'flex-start'
    }
  },
  containerList: {
    maxHeight: 322,
    overflowY: 'scroll',
    [theme.breakpoints.down('sm')]: {
      width: 'inherit',
      padding: 0
    }
  },
  containerSearch: {
    width: '100%',
    marginTop: 15,
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: 0,
      alignItems: 'center',
      marginBottom: 10,
      '& > div': {
        marginLeft: 0,
        width: '100%'
      }
    }
  },
  autoComplete: {
    '&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]':
      {
        borderRadius: 25,
        padding: '0px 10px'
      },
    '& .MuiInputBase-root': {
      '&:hover': {
        borderColor: 'red'
      }
    }
  },
  searchBar: {
    border: '1px solid',
    borderColor: alpha(theme.palette.secondary.main, 0.1),
    borderRadius: 25,
    width: '100%'
  },
  needHelpContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  closeButton: {
    '&:hover': {
      backgroundColor: 'initial'
    }
  }
}));

const StyledCollapse = withStyles(theme => ({
  root: {
    width: '95vw !important'
  }
}))(Collapse);

const StyledCard = withStyles(theme => ({
  root: {
    zIndex: 9,
    margin: 4,
    width: 'calc(100vw - 332px)',
    textAlign: 'left',
    boxShadow:
      '0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)',
    [theme.breakpoints.down('md')]: {
      width: '90vw'
    }
  }
}))(Card);

const StyledButton = withStyles(theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 25,
    width: '25%',
    height: 50,
    fontSize: 16,
    boxShadow: '0 3px 6px #d7d7d7',
    [theme.breakpoints.down('sm')]: {
      width: 30,
      height: 45,
      minWidth: 45,
      borderRadius: 8
    }
  },
  label: {
    display: 'flex',
    fontFamily: 'sofia-pro',
    fontWeight: 100,
    lineHeight: '1.5rem',
    alignItems: 'center',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      '& .MuiTypography-root': {
        display: 'none'
      }
    }
  },
  startIcon: {
    margin: 0,
    marginRight: 10,
    '&.MuiButton-startIcon svg': {
      fontSize: 22,
      [theme.breakpoints.down('sm')]: {
        fontSize: 26,
        display: 'block'
      }
    },
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      marginRight: 'initial'
    }
  }
}))(Button);

const SearchButtonModalDesk = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [query, setQuery] = useState('""');
  const [queryComplete, setQueryComplete] = useState('""');
  const [getType, setGetType] = useState(null);
  const [activeContent, setActiveContent] = useState(false);
  const [activeFaq, setActiveFaq] = useState(false);
  const [activeHairdresser, setActiveHairdresser] = useState(false);
  const [inputValue, setInputValue] = useState(null);
  const classes = useStyles(open);
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (open) {
      setUrl(`/search?query=${query}${
      (getType && activeContent) || activeFaq || activeHairdresser
        ? `&filter=${getType}`
        : ''
    }`);
    } else {
      setUrl(null);
    }
  }, [open, inputValue]);

  const [{ data: searchData, error }] = useAxios(url ? { url, method: 'GET' } : null, {
    manual: !url,
  });

  useEffect(() => {
    if (searchData) {
      setData(searchData);
    }
  }, [searchData]);

  const handleOpen = () => {
    setOpen(false);
  }

  const handleChange = () => {
    setOpen(prev => !prev);
  };

  const handleAutoComplete = value => {
    if (value && value.length > 3) {
      setQueryComplete(value);
    }

    if (!value) {
      return null;
    }
  };

  const handleSearch = value => {
    if (!data) {
      return null;
    }

    setInputValue(value);

    if (value && value.length > 3) {
      setQuery(encodeURI(value));
    } else if (value.length < 3) {
      setQuery('""');
    }
  };

  if (!data) {
    return <p>rien</p>;
  }

  const handleActive = type => {
    if (type === 'content') {
      setActiveContent(prev => !prev);
      setActiveHairdresser(false);
      setActiveFaq(false);
    }

    if (type === 'faq') {
      setActiveContent(false);
      setActiveHairdresser(false);
      setActiveFaq(prev => !prev);
    }

    if (type === 'hairdresser') {
      setActiveContent(false);
      setActiveHairdresser(prev => !prev);
      setActiveFaq(false);
    }
  };

  const filterOptions = createFilterOptions({
    ignoreCase: true
  });

  const handleCloseText = e => {
    setInputValue('');
  };

  return (
    <div className={classes.root}>
      <Fab
        elevation={3}
        onClick={handleChange}
        className={open ? clsx(classes.fab, classes.fabOpen) : classes.fab}
      >
        <SearchIcon className={classes.fabIcon} />
      </Fab>
      <StyledCollapse in={open}>
        <StyledCard>
          <CardActions className={classes.sectionClose}>
            <IconButton size="small" onClick={handleOpen}>
              <CancelIcon className={classes.iconClose} />
            </IconButton>
          </CardActions>

          <CardContent style={{ boxShadow: '#ebebeb 0px 3px 4px' }}>
            <Container
              className={clsx(classes.container && classes.containerButton)}
            >
              <StyledButton
                onClick={e => {
                  setGetType('content');
                  handleActive('content');
                }}
                variant="contained"
                startIcon={<LibraryIcon />}
                style={{
                  backgroundColor: activeContent ? '#d3b16f' : '#fff',
                  color: activeContent ? '#fff' : '#000'
                }}
              >
                <Typography>{t('documentation.title')}</Typography>
              </StyledButton>
              <StyledButton
                onClick={e => {
                  setGetType('question');
                  handleActive('faq');
                }}
                variant="contained"
                startIcon={<FaqIcon />}
                style={{
                  backgroundColor: activeFaq ? '#d3b16f' : '#fff',
                  color: activeFaq ? '#fff' : '#000'
                }}
              >
                <Typography>FAQ</Typography>
              </StyledButton>
              <StyledButton
                onClick={e => {
                  setGetType('hairdresser');
                  handleActive('hairdresser');
                }}
                variant="contained"
                startIcon={<StoreIcon />}
                style={{
                  backgroundColor: activeHairdresser ? '#d3b16f' : '#fff',
                  color: activeHairdresser ? '#fff' : '#000'
                }}
              >
                <Typography>{t('hairdressers.hairdressers')}</Typography>
              </StyledButton>
            </Container>
            <Container className={classes.container}>
              <div className={classes.containerSearch}>
                {/* <Autocomplete
                  id="auto-complete"
                  options={!searchAutoComplete ? loading : searchAutoComplete}
                  getOptionLabel={option =>
                    option?.value !== null ? option?.value : ''
                  }
                  getOptionSelected={(option, value) =>
                    handleSearch(value, null)
                  }
                  noOptionsText={t('no_result')}
                  filterOptions={filterOptions}
                  variant="outlined"
                  onKeyUp={e => handleSearch(e.target.value, e.keyCode)}
                  className={classes.autoComplete}
                  renderInput={params => (
                    <TextField
                      onChange={e => handleAutoComplete(e.target.value)}
                      {...params}
                      placeholder={t('common:action.search.search')}
                      variant="outlined"
                      className={classes.searchBar}
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <>
                            <SearchIconBis color="primary" />
                            {params.InputProps.startAdornment}
                          </>
                        )
                      }}
                    />
                  )}
                /> */}

                <SearchInput
                  className={classes.searchBar}
                  icon={<SearchIconBis color="primary" />}
                  placeholder={t('common:action.search.search')}
                  onChange={e => handleSearch(e.target.value)}
                  endAdornment={
                    inputValue ? (
                      <InputAdornment position="end">
                        <IconButton
                          className={classes.closeButton}
                          onClick={handleCloseText}
                        >
                          <CloseIcon className="text-18" />
                        </IconButton>
                      </InputAdornment>
                    ) : null
                  }
                  value={inputValue || ""}
                />

                <Hidden smUp>
                  <IconButton
                    component={Link}
                    to="/faq"
                    onClick={() => setOpen(false)}
                  >
                    <InterrogationIcon
                      style={{ fontSize: 40, display: 'none' }}
                    />
                  </IconButton>
                </Hidden>
              </div>
            </Container>
          </CardContent>

          <CardContent>
            <Container className={classes.containerList}>
              {/* {data &&
              searchAutoComplete &&
              data.length > 0 &&
              searchAutoComplete.length > 0 ? (
                <>
                  {data?.map((item, index) => {
                    return <DisplaySearchItem query={query} setOpen={setOpen} item={item} index={index} />;
                  })}
                </>
              ) : (
                <p>{t('no_result')}</p>
              )} */}
              {data && data.length > 0 ? (
                <>
                  {data?.map((item, index) => {
                    return (
                      <DisplaySearchItem
                        query={query}
                        setOpen={setOpen}
                        item={item}
                        index={index}
                      />
                    );
                  })}
                </>
              ) : (
                <p>{t('no_result')}</p>
              )}
            </Container>
          </CardContent>

          <Hidden mdDown>
            <CardContent>
              <div className={classes.needHelpContainer}>
                <IconButton
                  component={Link}
                  to="/faq"
                  onClick={() => setOpen(false)}
                >
                  <InterrogationIcon style={{ fontSize: 40 }} />
                </IconButton>
                <Typography>{t('need_help')}</Typography>
              </div>
            </CardContent>
          </Hidden>
        </StyledCard>
      </StyledCollapse>
    </div>
  );
};

export default SearchButtonModalDesk;
